import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Login from '../../pages/login';
import Dashboard from '../../pages/dashboard/';

function App() {
  return (
    <BrowserRouter>
    <Routes>
        <Route exact path="/sta/" element={<Login />} />
        <Route path="/sta/:id" element={<Login />} />  
        <Route path="/dashboard" element={<Dashboard />} />                
    </Routes>
    </BrowserRouter>
  );
}

export default App;
